import { render, staticRenderFns } from "./comp_BookEditorInput-LangSelect.vue?vue&type=template&id=0fa3aa48&scoped=true&"
import script from "./comp_BookEditorInput-LangSelect.vue?vue&type=script&lang=js&"
export * from "./comp_BookEditorInput-LangSelect.vue?vue&type=script&lang=js&"
import style0 from "./comp_BookEditorInput-LangSelect.vue?vue&type=style&index=0&id=0fa3aa48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa3aa48",
  null
  
)

export default component.exports